export const EMPTY_USERNAME = "Please enter a username.";
export const EMPTY_PASSWORD = "Please enter a password.";
export const EMPTY_NAME = "Please enter a name.";
export const EMPTY_GROUP_NAME = "Please enter a group name.";
export const EMPTY_EMAIL = "Please enter an email.";
export const EMPTY_TERMS_PRIVACY =
  "Check the box to affirm that you have read and agree with our Terms of Use and Privacy Policy.";
export const EMPTY_AGE_OVER_13 =
  "Check the box to affirm that you are between 13 to 17 years of age";
export const EMPTY_AGE_OVER_18 =
  "Check the box to affirm that you are 18 years of age or older.";
export const NO_TEXT_IN_FIELD =
  "Don't forget to write something before posting!";

export const INVALID_EMAIL = "Please enter a valid email address.";
export const INVALID_PASSWORD_MATCH = "Both passwords must match.";

export const INVALID_NAME_SIZE = "Please enter a valid name.";
export const INVALID_USERNAME =
  "Username must be between 6 to 20 characters and can contain only numeric digits and letters without spaces.";
export const INVALID_PASSWORD =
  "Password must be between 6 to 20 characters which contain at least one numeric digit, one uppercase and one lowercase letter.";
export const INVALID_RECOVERY_OPTION =
  "Would you like to recover your username or password?";

export const NOT_AVAILABLE_USERNAME = "Username is taken.";

export const INCORRECT_LOGIN = "Incorrect username/password combination.";
export const USER_ACCOUNT_DISABLED =
  "Your account is disabled. Please contact us at hello@katamundi.com.";
export const USER_ACCOUNT_NOT_ACTIVATED =
  "Your account is not activated. Check your email to verify your account.";
export const USER_REGISTRATION_EXIST =
  "You already have an account. Please sign in.";

export const USER_REGISTRATION_SUCCESS =
  "Thanks for signing up! Please verify your email and sign in.";
export const DOES_NOT_EXISTS = "DOES_NOT_EXISTS";
export const INVALID_ACCOUNT_DETAILS = "Invalid log-in information. Username and password are case sensitive."
//Friend page
export const FRIENDS = "Friends";
export const CHILDREN = "Children";
export const INVITATIONS = "Invitations";
export const INVITE = "Invite";
export const INVITE_URL = "invite";
export const INVITE_SENT = "Invite Sent";
export const REQUESTS = "Requests";
export const REQUEST = "Request";
export const REQUEST_LOWERCASE = "request";
export const BUTTON_VIEW_INVITATION = "View Invitation";
export const BUTTON_VIEW_REQUEST = "View Request";
export const BUTTON_VIEW = "View";
export const VIEW = "view";
export const INVITE_TITLE = "Invite ";
export const INVITE_MESSAGE =
  "Become friends by sending an invitation to them! The invitation will be sent to their friend invitation list.";
export const BUTTON_CANCEL = "Cancel";
export const PREFIX_SENT = "Sent ";
export const PREFIX_RECEIVED = "Received ";
export const PREFIX_SINCE = "Friends since ";
export const SINCE = " since ";
export const HELLO_FRIENDS = "Hello Friends";
export const FIND_NEW_FRIENDS = "Find New Friends";
export const RECOMMENDATIONS = "Recommendations";
export const PEOPLE_YOU_MAY_KNOW = "People You May Know";
export const SEARCH_FOR_NEW_FRIENDS =
  "No results found here… try searching for new friends!";
export const NO_FRIENDS = "You Don't Have Any Friends Yet";
export const FIND_YOUR_FRIENDS = "Type in a friend's username";
export const NO_NEW_FRIEND_REQUESTS = "No New Friend Requests";
export const NO_NEW_FRIEND_INVITATIONS = "No New Friend Invitations";
export const FRIEND_REQUESTS = "Friend Requests";
export const GROUP_REQUESTS = "Group Requests";
export const SEARCH = "Search";
export const ACCEPT = "Accept";
export const DECLINE = "Decline";
export const ARE_YOU_FRIENDS = "Are you friends with ";
export const ACCEPT_MOTIVATION =
  "Accept to become friends and start catapulting social good around the world together. ";
export const CANCEL_REQUEST = "Cancel Friend Request to ";
export const CANCEL_MESSAGE =
  "Doing so will remove your friend request from their invitation list.";
export const NOT_SHARED = "not shared";
export const NEWS = "News";
export const ABOUT_ME = "About me";
export const IMPACT = "Impact";
export const TRIBE = "Tribe";
export const MARKET = "Market";
export const PROJECTS = "Projects";
export const SPOTLIGHT = "Spotlight";
export const ALBUM = "Album";
export const COMINGSOON = "Coming Soon!";
export const MANAGE_CHILD_TRIBE = "Manage Your Child's Tribe";
export const CHILD_FRIEND_REQUESTS = "Child Friend Requests";
export const FRIENDUSERDETAIL = "Friend's User Detail Page is";
export const PUBLICUSERDETAIL = "Publicly Visible User Details Page is";
export const SELECTED = "Selected";
export const RECEIVED = "received";
export const FROM = "From: ";
export const TO = "To: ";
export const GUARDIAN_REVIEW = "guardian_review";
export const REVIEW = "review";
export const FRIEND = "friend";
export const DO_YOU_APPROVE =
  "Do you approve your child becoming friends with ";
export const PROFILE_RESTRICTION_MESSAGE =
  "Only friends can view this private profile.";
export const REQUEST_SENT_MESSAGE ="An invitation has already been initiated between you and ";

/*GROUPS*/
export const GROUPS = "Groups";
export const PUBLIC = "PUBLIC";
export const PRIVATE = "PRIVATE";
export const NO_GROUP = "You're Not Part of Any Groups Yet";
export const NO_NEW_GROUP_REQUESTS = "No New Group Requests";
export const NO_NEW_GROUP_INVITATIONS = "No New Group Invitations";
export const NO_NEW_GROUP_REQUESTS_INVITATIONS =
  "No New Group Requests or Invitations";
export const NEW_GROUP_BANNER_MESSAGE =
  "Want to start your own local group with your family, friends, church, or other groups? Click here to get started.";
export const START_NEW_GROUP = "Start A New Group";
export const LETS_GO = "Let's Go";
export const FIND_NEW_MEMBERS = "Find New Members";
export const FIND_NEW_GROUPS = "Find New Groups";
export const NEW_MEMBERS = "New Members";
export const GROUPS_PAGE = "groups page";
export const NEW_MEMBERS_MESSAGE =
  "Send out a group invitation to them! The invitation will be sent to their group invitation list.";
export const MEMBERS = "Members";
export const NO_MEMBERS = "No Members";
export const MEMBER_SINCE = "Member since: ";
export const ALL_GROUP_INVITATIONS = "All Invitations";
export const CHILD_GROUP_REQUEST = "Child Group Request";
export const CHILD_GROUP_INVITATIONS = "Child Group Invitations";
export const ALL_GROUP_REQUESTS = "All Requests";
/*URL keywords for groups*/
export const GROUP_INVITE_URL = "group-invite";
export const JOIN_URL = "join";
export const GROUP_MEMBER_REVIEW_URL = "member-review";
export const GROUP_OWNER_REVIEW_URL = "owner-review";
export const GROUP_MODERATOR_REVIEW_URL = "moderator-review";

/*Group Form*/
export const GROUP_NAME = "Group Name*";
export const WHATS_YOUR_GROUP_NAME = "What's the name of your group?";
export const ABOUT_US = "About Us";
export const ADD_GROUP_DESCRIPTION = "Add a description for your group";
export const GROUP_MISSION = "Our Group's Mission";
export const GROUP_MISSION_PLACEHOLDER = "Describe your group's mission";
export const WE_SUPPORT = "We Will Make the World a Better Place by Supporting";
export const WE_SUPPORT_PLACEHOLDER =
  "Concepts or categories your group supports";
export const GROUP_FAVORITE_CAUSES = "Our Favorite Causes";
export const GROUP_SUPPORT_PLACEHOLDER = "Causes your group supports";
export const CONTACT_INFO = "Contact Info";
export const MOBILE_PLACEHOLDER = "phone";
export const EMAIL = "Email";
export const EMAIL_PLACEHOLDER = "info@groupname.com";
export const WEBSITE = "Website";
export const WEBSITE_PLACEHOLDER = "YourNonProfit.com";
export const LOCATION = "Location";
export const STREET = "Street";
export const STREET_PLACEHOLDER = "1234 StreetName Rd";
export const CITY = "City";
export const STATE = "State";
export const ZIP = "Zip";
export const ZIP_PLACEHOLDER = "Zip Code";
export const DONE = "Done";
export const REQUIRED_FIELD = "* Required Field";
export const GROUP_VISIBILITY = "Group Visibility";
export const US_STATES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HA",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

/*Group Profile*/
export const MEMBER = "Member";
export const OWNER = "Owner";
export const MODERATOR = "Moderator";
export const OUR_FAVORITE_CAUSES = "Our favorite causes are...";
export const RECEIVED_INVITE = "received-invite";
export const RECEIVED_REQUEST = "received-request";
export const RECEIVED_INVITE_FROM_GROUP = "Group to User invite";
export const GROUP_RECEIVED_INVITE_MOTIVATION = " has invited you to join ";
export const ACCEPT_GROUP_MOTIVATION_1 = "Accept the invitation to join ";
export const ACCEPT_GROUP_MOTIVATION_2 =
  " and work together on spreading good around the world.";
export const GROUP_INVITE_CANCEL_MESSAGE1 =
  "Canceling the invitation will remove it from ";
export const GROUP_INVITE_CANCEL_MESSAGE2 =
  "'s received group invitations list...";
export const GROUP_ACCEPT_TITLE = "Accept the group invitation sent to ";
export const GROUP_CANCEL_TITLE = "Cancel the group invitation sent to ";
export const GROUP_CANCEL_WARNING1 =
  "Are you sure you cancel the invitation? If you do, you or another member can always re-invite them later on.";
export const GROUP_CANCEL_WARNING2 =
  "If you are a Moderator or Owner of this group, canceling this invitation will delete all your group's invitations to ";
export const ACCEPT_CANCEL_INVITATION = "Yes, cancel the invitation";

export const GROUP_RECEIVED_REQUEST_TITLE1 = "Accept ";
export const GROUP_RECEIVED_REQUEST_TITLE2 = "'s request to join?";
export const GROUP_RECEIVED_REQUEST_MESSAGE1 =
  "Accept the group request sent from ";
export const GROUP_RECEIVED_REQUEST_MESSAGE2 =
  " and work together on spreading good around the world.";
export const GROUP_DECLINE_RECEIVED_REQUEST_TITLE =
  "Decline the request to join from ";
export const GROUP_DECLINE_RECEIVED_REQUEST_WARNING =
  "Are you sure you decline the request? If you do, you or another member can always invite them later on.";
export const ACCEPT_DECLINE_RECEIVED_REQUEST = "Yes, decline the request";

export const GROUP_CANCEL_REQUEST_TITLE = "Cancel the group request sent to ";
export const GROUP_CANCEL_REQUEST_WARNING1 =
  "Are you sure you cancel the request? If you do decide to cancel, you can always connect with them later on.";
export const GROUP_REQUEST_CANCEL_MESSAGE1 =
  "Doing so will remove your request from ";
export const GROUP_REQUEST_CANCEL_MESSAGE2 =
  "'s received group request list...";

export const GROUP_DECLINE_TITLE = "'s invitation to join ";
export const GROUP_DECLINE_WARNING =
  "Are you sure you decline? If you decline now, you can always connect with them later on.";
export const UPLOAD_COVER_PHOTO = "Upload Cover Photo";

/*Group member manage settings */
//change member role
export const CHANGE_ROLE = "Change Role";
export const CHANGE_ROLE_DESCRIPTION = "'s current role is: ";
export const SELECT_NEW_ROLE = "Select a new role: ";
export const ERROR_SELECT_A_ROLE = "Please select one of the roles.";
//remove member from group
export const REMOVE_FROM_GROUP = "Remove From Group";
export const REMOVE = "Remove ";
export const REMOVE_FROM_GROUP_WARNING1 =
  "Are you sure you want to do that? It might be difficult for ";
export const REMOVE_FROM_GROUP_WARNING2 =
  " to become a member of your group again.";
export const ACCEPT_REMOVE = " Yes, remove ";
// leave group
export const LEAVE_GROUP = "Leave Group";
export const YES_LEAVE_GROUP = "Yes, leave ";
export const LEAVE = "Leave ";
export const LEAVE_GROUP_WARNING1 =
  "Are you sure you want to do that? It might be difficult for you to become a member of ";
export const LEAVE_GROUP_WARNING2 = " again.";

export const JOIN_GROUP_TITLE = "Want to join ";
export const JOIN = "Join";
export const JOIN_GROUP_DESCRIPTION =
  " is a public group. This means there always accepting new members and you can join right away!" +
  ' Press "Join" to become a member!';

export const REQUEST_TO_JOIN = "Request to join";
export const REQUEST_SENT = "Request sent";
export const JOIN_PRIVATE_GROUP = "Join Private Group";
export const JOIN_PRIVATE_GROUP_DESCRIPTION =
  " is a private group. This means you first have to send a request to join." +
  " Once they accept your request, you'll become a member of their group.";

/* Group Projects */
export const SELECT_A_GROUP = "Select A Group.";
export const SELECTED_GROUP = "You've selected ";
export const SELECTED_GROUP2 =
  ". This will invite every member of the group to your project.";

/*Newsfeed*/
export const NO_NEWSFEED = " has no newsfeed posts";
export const NO_USER_FEED = "You have no newsfeed posts...";
export const WRITE_COMMENT = "Write a comment...";
export const POST = "Post";
export const WHATS_ON_YOUR_MIND = "What's on your mind?";
export const POSTED_ON = "Posted on";
export const UPLOAD_MEDIA = "Upload Photo / Video";
export const UPLOAD_IMAGE = "Upload Photo";
export const UPLOAD_PHOTO_VIDEO = "Upload Photo/Video";
export const UPLOAD_PHOTO = "Upload Photo";
export const YOUTUBE_VIDEO_PREVIEW = "Youtube Video Preview";
export const UPLOAD_VIDEO = "Upload Video";
export const UPLOAD_TO_ALBUM = "Upload as Is";
export const UPLOAD_AND_EDIT = "Upload and Edit";

export const MY_FAVORITE_THINGS = "My favorite things are...";
export const MY_DREAM = "I have a dream, that one day...";
export const MY_HERO = "My hero is...";
export const MY_SUPERPOWERS = "I have the superpower(s) to...";
export const I_SUPPORT = "I will make the world a better place by supporting:";
export const FAVORITE_CAUSES = "My favorite causes are...";
export const BLOCK_USER = "Block ";
export const BLOCKED_USERS = "Blocked Users";
export const BLOCK = "Block ";
export const BLOCKED = "Blocked ";
export const UNBLOCK = "Unblock";
export const YOUR_BLOCKED = "Your Blocked Users";
export const HAVE_NOT_BLOCKED_USERS = "You have not blocked any users";
export const HAS_NOT_BLOCKED_USERS = " has not blocked any users";
export const LIKE = "Like";

/*Account Page*/
export const EMAIL_COLON = "Email:";
export const TELL_ABOUT_YOU = "Tell us about yourself.";
export const FULL_NAME_COLON = "Full Name:";
export const FULL_NAME = "Full Name";
export const NAME_COLON = "Name:";
export const USERNAME_COLON = "Username:";
export const PASSWORD_COLON = "Password:";
export const PASSWORD = "Password";
export const CONFIRM_PASSWORD = "Confirm Password";
export const CONFIRM_PASSWORD_COLON = "Confirm Password:";
export const OLD_PASSWORD = "Current Password";
export const OLD_PASSWORD_COLON = "Current Password:";
export const ADDRESS = "Address";
export const ADDRESS_COLON = "Address:";
export const MOBILE = "Mobile";
export const MOBILE_COLON = "Mobile:";
export const BIRTH_DATE_COLON = "Birth Date:";
export const SCHOOL_COLON = "School:";
export const SCHOOL_NAME = "School Name";
export const SCHOOL_GRADE_COLON = "School Grade: ";
export const SELECT_GRADE = "Select School Grade";
export const TELL_MAKES_YOU_SMILE =
  "Tell us what always puts a smile on your face.";
export const YOUR_HEROES = "My heroes are... ";
export const HEROES = "Heroes";
export const THE_SUPERPOWERS = "The Superpowers";
export const TELL_YOUR_POWERS =
  "Tell us your special strengths and abilities you can use to make the world a better place.";
export const THE_CAUSES = "The Causes";
export const NAME_YOUR_CAUSES = "Name some of your favorite causes";
export const ACCEPT_TOS_PRIVACY =
  "By clicking the box, I affirm that I have read and agree to Katamundi's Terms of Use and Privacy Policy.";
export const AFFIRM_GUARDIAN_DUTY =
  "By clicking the box, I affirm that I am responsible for supervising the use of and conduct on Katamundi by my minor children under 13 years old.";
export const CONSENT_CONTENT_SHARING =
  "By clicking the box, I consent to allow my minor children under 13 years old to join projects that may be public or private, and for sharing videos and images with the Katamundi community.";
export const PAY_CONSENT_FEE =
  "By clicking the box, I agree to pay a nominal fee of $1.00 per child under 13 years old as required by The Children's Online Privacy Protection Act of 1998 (COPPA) to show verifiable parental consent";

/*Content Creation Suite*/
export const CONTENT_CREATION_SUITE = "Content Creation Suite";

/*Popup warnings and text*/
export const BLOCK_WARNING1 = "Are you sure you want to block ";
export const BLOCK_WARNING2 =
  "While doing so will block them from contacting you, you may always remove the block later on. ";
export const BLOCK_WARNING =
  "This may also block the user and their children from you and your children! ";
export const CANCEL_TITLE = "Cancel the friend request sent to ";
export const CANCEL_WARNING1 =
  "Are you sure you want to cancel the invitation sent to ";
export const CANCEL_WARNING2 =
  "? If you cancel now, you can always connect with them later on.";
export const DECLINE_TITLE = "Decline the friend request from ";
export const DECLINE_WARNING1 = "Are you sure you want to decline ";
export const DECLINE_WARNING2 =
  "'s invitation? If you decline now, you can always connect with them later on.";
export const ACCEPT_DECLINE = "Yes, I want to decline";
export const ACCEPT_CANCEL = "Yes, cancel the request";
export const ACCEPT_BLOCK = "Yes, I want to block";
export const DECLINE_BLOCK = "Cancel";
export const DECLINE_CANCEL = "Go Back";
export const ADD = "Add";
export const ADD_YOUTUBE_URL = "Add a YouTube URL";
export const REMOVE_VIDEO = "Remove video?";
export const TYPE_URL = "Type the url here";
export const SAVE = "Save";
export const DECLINE_CHILD_FRIEND_REQUESTS_TITLE =
  "Decline your child to become friends with ";
export const DECLINE_CHILD_FRIEND_REQUESTS_WARNING1 =
  "Are you sure you want to decline your child becoming friends with ";
export const DECLINE_CHILD_FRIEND_REQUESTS_WARNING2 =
  "If you decline now, you can always connect with them later on.";
export const DECLINE_CHILD_GROUP_REQUESTS_TITLE =
  "Decline your child to become member of ";
export const DECLINE_CHILD_GROUP_REQUESTS_WARNING1 =
  "Are you sure you want to decline your child becoming member of ";
export const DECLINE_CHILD_GROUP_REQUESTS_WARNING2 =
  "If you decline now, your child can always try to connect with the group later on.";

export const COMMENT_THREAD = "Comment Thread";
export const POST_COMMENT = "Post a comment";
export const IMPACT_SOON = "Impact coming soon";
export const TRIBE_SOON = "Tribe coming soon";
export const NEWS_SOON = "News coming soon";
export const ALBUM_SOON = "Album coming soon";
export const HOW_THIS_WORKS = "How Does This Work?";
export const VIEW_MORE_POSTS = "View More Posts";

//Search Types
export const USERNAME = "Username";

// Backend Response messages
export const BACKEND_SUCCESS = "SUCCESS";
export const BACKEND_ACTIVATE_ACCOUNT = "ACTIVATE_ACCOUNT";
export const BACKEND_INCORRECT_EMAIL_OR_PASSWORD =
  "INCORRECT_EMAIL_OR_PASSWORD";
export const BACKEND_DISABLED_USER = "DISABLED_USER";
export const BACKEND_USER_ALREADY_EXISTS = "USER_ALREADY_EXISTS";

//Backend Posts Topics
export const POSTS_STARTED_PROJECT = "STARTED_PROJECT";
export const FRIEND_STARTED_PROJECT = "FRIEND_STARTED_PROJECT";
export const POSTS_RECEIVED_INVITATION = "RECEIVED_INVITATION";
export const POSTS_JOINED_PROJECT = "JOINED_PROJECT";
export const POSTS_COMPLETED_PROJECT = "COMPLETED_PROJECT";
export const POSTS_GOAL_SET = "GOAL_SET";
export const POSTS_FRIEND_GOAL_SET = "FRIEND_GOAL_SET";
export const POSTS_FRIEND_COMPLETED_PROJECT = "FRIEND_COMPLETED_PROJECT";
export const CUSTOM_POST = "CUSTOM_POST";
export const FRIEND_CUSTOM_POST = "FRIEND_CUSTOM_POST";
export const GROUP_CUSTOM_POST = "GROUP_CUSTOM_POST";
export const FRIEND_GROUP_CUSTOM_POST = "FRIEND_GROUP_CUSTOM_POST";
export const GROUP_MEMBER_CUSTOM_POST = "GROUP_MEMBER_CUSTOM_POST";

//Mobile_toolbar
export const MENU = "Menu";
export const MY_ACCOUNT = "My Account";
export const MY_CHILDREN = "My Children";
export const PAYMENT = "Payments";
export const T_AND_C = "Terms & Conditions";
export const SECURITY_PRIVACY = "Security & Privacy";
export const LOGOUT = "Logout";

/* Projects Pages */
export const NO_INVITES = "Invitations not available";
export const PLANNING = "Planning";
export const NO_PROJECTS = "Projects not available";
export const ACTIVE = "Active";
export const START_PROJECT = "Start a Project";
